import { X, ThumbsUp, RotateCcw } from 'lucide-react'

interface SwipeControlsProps {
  onPass: () => void
  onLike: () => void
  onBookmark?: () => void
}

export function SwipeControls({ onPass, onLike, onBookmark }: SwipeControlsProps) {
  return (
    <div className="flex items-center justify-center gap-6">
      {/* Pass button */}
      <button
        onClick={onPass}
        className="group relative flex items-center justify-center w-16 h-16 rounded-full bg-gray-700 hover:bg-gray-600 active:scale-95 transition-all duration-200 shadow-lg"
        aria-label="Ikke interessert"
      >
        <X className="w-8 h-8 text-white group-hover:scale-110 transition-transform" />
      </button>

      {/* Bookmark button */}
      <button
        onClick={onBookmark}
        className="group relative flex items-center justify-center w-16 h-16 rounded-full bg-blue-500 hover:bg-blue-400 active:scale-95 transition-all duration-200 shadow-lg"
        aria-label="Bokmerke"
      >
        <svg className="w-7 h-7 text-white group-hover:scale-110 transition-transform" fill="currentColor" viewBox="0 0 20 20">
          <path d="M5 4a2 2 0 012-2h6a2 2 0 012 2v14l-5-2.5L5 18V4z" />
        </svg>
      </button>

      {/* Like button */}
      <button
        onClick={onLike}
        className="group relative flex items-center justify-center w-16 h-16 rounded-full bg-green-600 hover:bg-green-500 active:scale-95 transition-all duration-200 shadow-lg"
        aria-label="Interessert"
      >
        <ThumbsUp className="w-8 h-8 text-white group-hover:scale-110 transition-all" />
      </button>
    </div>
  )
}
